module.exports = __webpack_public_path__ + "static/media/marker-low.9316fb7f.svg";